
  import PTitle from '@/components/config/PTitle.vue'
  import { Component, Watch } from 'vue-property-decorator'
  import axios from 'axios'
  import StockData from '@/components/config/StockData.vue'
  import { isValidNumber, parseToNumber, removeAccents } from '@/utils/general'
  import GDatePicker from '@/components/core/input/GDatePicker.vue'
  import GCostField from '@/components/core/input/GCostField.vue'
  import GRut from '@/components/core/input/GRut.vue'
  import GPpu from '@/components/core/input/GPpu.vue'
  import dayjs from 'dayjs'
  import ImportAttribute from '@/components/config/importStock/ImportAttribute.vue'
  import CreateVersion from '@/components/config/importStock/CreateVersion.vue'
  import AddRecord from '@/components/config/importStock/AddRecord.vue'
  import _ from 'lodash'
  import GFiles from '@/components/core/files/GFiles.vue'
  import { CavCurrOwners } from '@/entities/files/CavCurrOwners'
  import { updateJWT } from '@/store/resources/form/actions'
  import { ImportStockView } from '@/components/config/importStock/ImportStockView'
  import GWarningMessage from '@/components/core/GWarningMessage.vue'

  const { VUE_APP_BASE_URL } = process.env

@Component({
  components: { PTitle, StockData, GDatePicker, GCostField, GRut, ImportAttribute, GFiles, CreateVersion, AddRecord, GWarningMessage, GPpu },
})
  export default class SystemImportStock extends ImportStockView {
  selectErrors: boolean = false;
  dialog: boolean = true;
  file: File | null = null;
  stocks = []
  allRecords = 0
  existingRecords = 0
  clearedLocalStorage=false
  total = 0
  tdKey = 0
  totalAnalyzed = 0
  removePPU: boolean = false
  displayError = false
  errorReadingFile = 'Error al leer el archivo, comprueba que sea la plantilla que descargaste'
  dataTableData = []
  importDialogImported= false
  changeKey = 0
  stockImported: any[] = []
  selectedItems: any[] = []
  selectedRecords: any[] = [];
  cancelDialog: boolean = false;
  importDialog = false
  importDialogText = ''
  importDialogTitle = ''
  importDialogRedirect = false
  submittingMultiple: boolean = false
  cavErrorMessages: Record<string, any[]> = {}
  modelErrorMessages: Record<string, string> = {}
  versionErrorMessages: Record<string, string> = {}
  brandErrorMessages: Record<string, string> = {}
  existingPlates: string[] = []
  cleanForm= false
  filteredOutPlates: string[] = []
  plateExistsCache: Record<string, any> = {}
  currentItemWithPlateError: any = null;
  existingStock: any[] = [];
  showAddRecordDialog: boolean = false;
  editRecordData: any = null;
  existingStockHeaders = [
    { text: 'Patente', value: 'ppu', align: 'center', sortable: false },
    { text: 'Año', value: 'year', align: 'center', sortable: false },
    { text: 'Marca', value: 'brand', align: 'center', sortable: false },
    { text: 'Modelo', value: 'model', align: 'center', width: '200px', sortable: false },
    { text: 'Versión', value: 'version', align: 'center', width: '250px', sortable: false },
    { text: 'Estado', value: 'status', align: 'center', width: '200px', sortable: false },
  ];

  headers: Array<{ text: string; value: string; align?: string; width?: string }> = [
    { text: 'Seleccionar', value: 'select', align: 'center', width: '100px' },
    { text: 'Editar', value: 'edit', align: 'center', width: '80px' },
    { text: 'Acción', value: 'action', align: 'center', width: '100px' },
    { text: 'Cav', value: 'cav', align: 'center', width: '340px' },
    { text: 'Patente', value: 'ppu', align: 'center', width: '200px' },
    { text: 'Año', value: 'year', align: 'center', width: '200px' },
    { text: 'Marca', value: 'brand', align: 'center', width: '250px' },
    { text: 'Modelo', value: 'model', align: 'center', width: '250px' },
    { text: 'Versión', value: 'version', align: 'center', width: '350px' },
    { text: 'Otra versión', value: 'otherVersion', align: 'center', width: '200px' },
    { text: 'Código SII', value: 'attributes', align: 'center', width: '200px' },
    { text: 'Tracción', value: 'traction', align: 'center', width: '150px' },
    { text: 'Transmisión', value: 'transmission', align: 'center', width: '150px' },
    { text: 'Combustible', value: 'fuel', align: 'center', width: '150px' },
    { text: 'Propietario', value: 'owner', align: 'center', width: '300px' },
    { text: 'Tipo de persona', value: 'personType', align: 'center', width: '200px' },
    { text: 'RUT', value: 'uid', align: 'center', width: '200px' },
    { text: 'N° Dueños', value: 'owners', align: 'center', width: '100px' },
    { text: 'Tipo de adquisición', value: 'acquisitionType', align: 'center', width: '250px' },
    { text: 'Fecha de compra', value: 'date', align: 'center', width: '200px' },
    { text: 'ID LLAVE/ CARPETA', value: 'key', align: 'center', width: '200px' },
    { text: 'Kilometraje', value: 'mileage', align: 'center', width: '200px' },
    { text: 'Precio de compra', value: 'purchasePrice', align: 'center', width: '200px' },
    { text: 'Precio de lista', value: 'priceList', align: 'center', width: '200px' },
    { text: 'Descuento', value: 'discount', align: 'center', width: '200px' },
    { text: 'Bono de renovación', value: 'renewalBonus', align: 'center', width: '250px' },
  ]

  fields = {
    cav: {
      properties: {
        label: '',
        accept: '',
        fileTypeId: null,
        multiple: false,
        name: '',
        appendOuterIcon: '',
      },
    },
  }

  showCreateVersionDialog: boolean = false;
  currentItem: any = null;
  suggestedVersion: string = '';
  ppuRules = [
    v => !!v || 'Campo requerido',
    v => {
      const plate = v?.toUpperCase()
      if (plate && this.plateExistsCache[plate] && this.plateExistsCache[plate].exists) {
        return 'Esta patente ya existe en el sistema'
      }
      return true
    },
  ]

  async mounted () {
    const fileInfo = await this.fetchData({
      query: { name: 'find', model: 'FileParameter' },
      filter: { process: { table_name: { _eq: 'negotiation' } } },
    })

    this.setProperties(fileInfo, 'cav', 'cav')
  }

  setProperties (fileInfo, fileTypeName, fieldKey) {
    if (!fileInfo?.length) return
    const info = fileInfo.find(fileParameter => fileParameter.name === fileTypeName)
    if (info) {
      this.fields[fieldKey].properties.accept = info.fileType.mimes
      this.fields[fieldKey].properties.multiple = info.multiple
      this.fields[fieldKey].properties.fileTypeId = info.fileType.id
      this.fields[fieldKey].properties.name = info.name
      this.fields[fieldKey].properties.label = info.description
      this.fields[fieldKey].properties.required = info.required
      this.fields[fieldKey].properties.icon = info.fileType.icon
    }
  }

  closeDialog () {
    this.dialog = false
  }

  handleFileChange (file: File) {
    this.file = file
    this.displayError = false
    const name = file.name
    const size = file.size.toString()
    const savedName = localStorage.getItem('importStocks_fileName')
    const savedSize = localStorage.getItem('importStocks_fileSize')
    if (savedName !== name || savedSize !== size) {
      localStorage.removeItem('importStocks_fileName')
      localStorage.removeItem('importStocks_fileSize')
      localStorage.removeItem('importStocks_data')
      localStorage.setItem('importStocks_fileName', name)
      localStorage.setItem('importStocks_fileSize', size)
    }
  }

  get existLocalStorage () {
    const { clearedLocalStorage } = this

    localStorage.setItem('clearedLocalStorage', clearedLocalStorage.toString())

    return !!localStorage.getItem('importStocks_fileName')
  }

  async uploadFile () {
    // Primero intentamos cargar desde localStorage
    if (await this.loadFromLocalStorage()) {
      return
    }

    if (!this.file) return

    this.loadingForm = true
    await this.processAndUploadFile()
  }

  /**
   * Intenta cargar los datos desde localStorage si existe el mismo archivo
   * @returns {boolean} true si los datos se cargaron correctamente
   */
  async loadFromLocalStorage () {
    if (!this.file) return false

    const name = this.file.name
    const size = this.file.size.toString()
    const savedName = localStorage.getItem('importStocks_fileName')
    const savedSize = localStorage.getItem('importStocks_fileSize')

    if (savedName === name && savedSize === size) {
      const savedData = localStorage.getItem('importStocks_data')
      if (savedData) {
        const data = JSON.parse(savedData)
        this.loadSavedData(data)
        this.dialog = false
        this.updateKeys()
        return true
      }
    } else {
      this.clearLocalStorage()
    }

    return false
  }

  /**
   * Carga los datos guardados en el objeto actual
   */
  loadSavedData (data) {
    this.stocks = data.stocks || []
    this.allRecords = data.allRecords || 0
    this.existingRecords = data.existingRecords || 0
    this.total = data.total || 0
    this.totalAnalyzed = data.totalAnalyzed || 0
    this.filteredOutPlates = data.filteredOutPlates || []
    this.dataTableData = data.dataTableData || []
    this.stocks.forEach(stock => {
      stock.checkAttributes = true
      stock.loading = false
    })
  }

  /**
   * Limpia los datos de localStorage
   */
  clearLocalStorage () {
    this.clearedLocalStorage = true
    localStorage.removeItem('importStocks_fileName')
    localStorage.removeItem('importStocks_fileSize')
    localStorage.removeItem('importStocks_data')
  }

  /**
   * Procesa y sube el archivo al servidor
   */
  async processAndUploadFile () {
    const formData = new FormData()
    formData.append('file', this.file)

    try {
      const { data: response } = await axios.post(`${VUE_APP_BASE_URL}/convert-pdf-to-image/upload-stock`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      console.log('response', response.data)
      await this.handleData(response.data)
      this.saveDataToLocalStorage()
    } catch (error) {
      console.log('error', error)
      this.displayError = true
      this.loadingForm = false
    }
  }

  /**
   * Guarda los datos procesados en localStorage
   */
  saveDataToLocalStorage () {
    if (!this.file) return

    localStorage.setItem('importStocks_fileName', this.file.name)
    localStorage.setItem('importStocks_fileSize', this.file.size.toString())
    localStorage.setItem('importStocks_data', JSON.stringify({
      stocks: this.stocks,
      allRecords: this.allRecords,
      existingRecords: this.existingRecords,
      total: this.total,
      totalAnalyzed: this.totalAnalyzed,
      filteredOutPlates: this.filteredOutPlates,
      dataTableData: this.dataTableData,
    }))
  }

  async handleData (data) {
    this.stocks = []
    this.filteredOutPlates = []

    // Si no hay datos, mostrar mensaje de error y no cerrar el diálogo
    if (data.length === 0) {
      this.displayError = true
      this.errorReadingFile = 'El archivo está vacío o no contiene registros válidos'
      this.loadingForm = false
      return
    }

    // Obtener las patentes existentes en el sistema con sus estados
    const existingAutos = await this.fetchData({
      query: { name: 'find', model: 'Auto' },
      filter: {
        _and: [
          { registration_plate: { _in: data.map(item => item.ppu.trim()) } },
          { process_status: { status: { name: { _nin: ['deprecated', 'retired', 'sold', 'not_match'] } } } },
        ],
      },
      limit: 1000,
      force: true,
    })
    // Map existingAutos to table structure for dialog
    this.existingStock = existingAutos.map(auto => ({
      ppu: auto.ppu,
      year: auto.year || auto.process_date?.slice(0, 4), // adjust if year field differs
      brand: auto.version?.version?.model?.brand?.name || '',
      model: auto.version?.version?.model?.name || '',
      version: auto.version?.version?.name || '',
      status: auto.status?.description || '',
    }))
    this.allRecords = data.length
    this.total = data.length - existingAutos.length
    this.existingRecords = existingAutos.length
    // Inicializar cache de patentes ya validadas
    this.plateExistsCache = {}

    // Extraer las patentes de vehículos con estados relevantes
    this.existingPlates = []

    // Procesar los autos existentes para extraer patentes y estados
    existingAutos.forEach(auto => {
      const plate = auto.ppu?.toUpperCase()
      const status = auto.status?.description

      this.existingPlates.push(plate)

      // Guardar en el cache con su estado
      this.plateExistsCache[plate] = {
        exists: true,
        status,
      }
    })

    // Procesar los datos del archivo
    await this.processImportData(data)

    this.dialog = false
    this.loadingForm = false

    // Verificar llaves duplicadas después de cargar todos los datos
    this.checkDuplicateKeys()

    // Mostrar notificación si hay patentes que ya existen
    if (this.filteredOutPlates.length > 0) {
      this.importDialogText = `Los siguientes vehículos ya se encuentran en el sistema: ${this.filteredOutPlates.join(', ')}`
      this.importDialog = true
      this.fillKeys()
    }
  }

  // Método auxiliar para procesar los datos de importación
  async processImportData (data) {
    for (const item of data) {
      // Verificar si la patente ya existe
      if (item.ppu && this.plateExistsCache[item.ppu.toUpperCase()] &&
        this.plateExistsCache[item.ppu.toUpperCase()].exists) {
        this.filteredOutPlates.push(item.ppu.toUpperCase())
        continue // Saltar este item ya que la patente ya existe
      }

      await new Promise(resolve => setTimeout(resolve, 100))

      const brand = await this.findBrand(item.year, item.brand)
      const model = await this.findModel(item.year, item.model, brand?.match)
      const version = await this.findVersion(item.year, item.version, model?.match, brand?.match)

      const acquisitionType = this.acquisitionType.find(type => {
        if (item.acquisitionType?.toLowerCase() === 'consigna') {
          return type.description.toLowerCase() === 'consignación'
        }
        return type.description.toLowerCase() === item.acquisitionType?.toLowerCase()
      })

      // Normalize and find matching fuel
      const fuelMatch = this.fuels.find(f => {
        if (!f.value || !item.fuel) return false
        const normalizedFuelValue = removeAccents(f.value.toLowerCase().trim())
        const normalizedItemFuel = removeAccents(item.fuel.toLowerCase().trim())
        // Exact match or synonyms for 'bencina' and 'gasolina'
        return normalizedFuelValue === normalizedItemFuel ||
          (normalizedFuelValue === 'bencina' && normalizedItemFuel === 'gasolina') ||
          (normalizedFuelValue === 'gasolina' && normalizedItemFuel === 'bencina')
      })
      const fuel = fuelMatch || { value: '' }

      const traction = this.traction.find(traction => removeAccents(traction.value.toLowerCase()) === removeAccents(item.traction?.toLowerCase())) || { value: '' }
      const transmission = this.transmissions.find(transmission => removeAccents(transmission.value.toLowerCase()) === removeAccents(item.transmission?.toLowerCase())) || { value: '' }
      const data = {
        year: item.year,
        brand,
        model,
        version,
        traction,
        transmission,
        fuel,
        owner: [],
        acquisitionType,
        date: this.normalizeDate(item.date),
        discount: item.discount,
        key: item.key,
        keyErrorMessage: '',
        mileage: item.mileage,
        owners: null,
        ppu: item.ppu,
        uid: [],
        personType: [],
        priceList: item.priceList,
        purchasePrice: item.purchasePrice,
        renewalBonus: item.renewalBonus,
        loading: false,
        generation: null,
        id: this.getGenerateRandomKey(),
        checkAttributes: true,
        errorMessages: '',
        cavId: null,
        idVersionYear: null,
        idGeneration: null,
        selected: false,
        discountWarningMessage: '', // Advertencia de descuento
        renewalBonusWarningMessage: '', // Advertencia de bono de renovación
        discountErrorMessage: '',
        renewalBonusErrorMessage: '',
      }
      this.updateKeys(data)
      // Validar campos inmediatamente después de crear el registro
      this.validateFields(data)
      this.stocks.push(data)
      this.totalAnalyzed += 1
      this.dataTableData = {
        ...this.dataTableData,
        [data.id]: _.cloneDeep(data),
      }
    }
  }

  async fetchModels (item) {
    if (item?.model?.firstLoad) {
      item.model.firstLoad = false
      return
    }

    this.dataTableData[item.id].model.data = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'Model',
        order: {
          name: 'asc',
        },
      },
      filter: {
        _and: [
          { id_brand: { _eq: item.brand.match?.id } },
          {
            versions: {
              years: {
                id_year: {
                  _gte: parseToNumber(item.year),
                  _lte: parseToNumber(item.year),
                },
              },
            },
          },
        ],
      },
      force: true,
    })
  }

  async fetchVersions (item) {
    if (item?.version?.firstLoad) {
      item.version.firstLoad = false
      return
    }

    this.dataTableData[item.id].version.data = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'VersionYear',
        order: {
          id_year: 'desc',
        },
      },
      filter: {
        _and: [
          {
            version: {
              _and: [
                {
                  model: { _and: [{ id_brand: { _eq: item.brand.match?.id } }, { id: { _eq: item.model.match?.id } }] },
                },
              ],
            },
          },
          {
            id_year: {
              _gte: parseToNumber(item.year),
              _lte: parseToNumber(item.year),
            },
          },
        ],
      },
      force: true,
    })

    // Hacemos una copia profunda de los datos para evitar referencias compartidas
    this.dataTableData[item.id].version.data = _.cloneDeep(this.dataTableData[item.id].version.data)

    // Resetear los atributos cuando se cambia de versión
    if (item.version && item.version.match) {
      item.traction = _.cloneDeep(item.traction || { value: '' })
      item.fuel = _.cloneDeep(item.fuel || { value: '' })
      item.transmission = _.cloneDeep(item.transmission || { value: '' })
      item.generation = null
      item.idGeneration = null
      item.idVersionYear = null
    }
  }

  async submitChanges (item) {
    item.loading = true

    try {
      await this.prepareItemVersion(item)
      await this.sendItemData(item)
      this.handleSuccessfulImport(item)
    } catch (error: any) {
      this.handleImportError(error, item)
    } finally {
      item.loading = false
    }
  }

  async prepareItemVersion (item) {
    // Verificar si la versión ya existe para el año seleccionado
    const versionYearExists = await this.checkVersionYearExists(item)

    if (!versionYearExists) {
      // Si no existe, extenderla desde una versión existente en otro año
      await this.extendVersionToSelectedYear(item)
    }

    // Verificar y asegurar que idVersionYear esté establecido correctamente
    if (item.version && item.version.match && item.version.match.id) {
      item.idVersionYear = item.version.match.id
      console.log(`Asegurando idVersionYear = ${item.idVersionYear}`)
    }
  }

  async sendItemData (item) {
    // Construir y enviar los datos al servidor
    const recordData = this.buildRecordData([item])
    console.log('Sending item data:', recordData)

    // Actualizar JWT antes de la llamada
    await updateJWT()
    const token = localStorage.getItem('apollo-token')

    // Enviar datos al endpoint
    await axios.post(`${VUE_APP_BASE_URL}/geniofiles/api/stock/upload-records`, recordData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    })
  }

  async handleSuccessfulImport (item) {
    // Mostrar mensaje de éxito
    this.loadNotification({
      message: 'Registro importado correctamente',
      color: 'success',
    })

    // Remover el item de stocks o marcarlo como procesado
    const index = this.stocks.findIndex(stock => stock.id === item.id)
    if (index !== -1) {
      this.stocks.splice(index, 1)
    }
    this.existingStock = []
    this.stockImported = await this.fetchData({
      query: { name: 'findLite', model: 'Stock' },
      filter: { stock_detail: { auto: { registration_plate: { _eq: item.ppu } } } },
      force: true,
    })
    this.importDialogTitle = 'Importación exitosa'
    this.importDialogText = `El vehículo ${item.ppu} importado correctamente`
    this.importDialogRedirect = this.stocks.length === 0
    this.importDialog = true
    this.fillKeys()
  }

  handleImportError (error, item) {
    console.error('Error al procesar el cambio:', error)
    // Mostrar mensaje de error
    this.loadNotification({
      message: `Error al importar el registro: ${error.message || 'Error desconocido'}`,
      color: 'error',
    })

    this.importDialogTitle = 'Error'
    this.importDialogText = `El vehículo ${item.ppu} está en error`
    this.importDialogRedirect = false
    this.importDialog = true
    this.fillKeys()
  }

  // Método para construir la estructura de datos para enviar al servidor
  buildRecordData (items: any[]) {
    return {
      records: items.map(item => {
        // Determinar idVersion
        const idVersion = item.idVersionYear || (item.version?.match?.id || null)
        // Determinar idGeneration solo si corresponde
        let idGeneration: number | null = null
        if (item.idGeneration && item.version?.match?.id === item.idVersionYear) {
          idGeneration = item.idGeneration
        }
        return {
          ppu: item.ppu,
          listPrice: item.priceList,
          buyPrice: item.purchasePrice,
          renewalBonus: item.renewalBonus,
          discount: item.discount,
          mileage: item.mileage,
          ownersNumber: item.owners,
          key: item.key,
          ownersInfo: item.owner.map((owner: string, index: number) => ({
            names: owner,
            uid: item.uid[index] || '',
          })),
          acquisitionType: item.acquisitionType?.description?.toLowerCase() === 'consignación'
            ? 'consignment'
            : 'purchase',
          cav: item.cav?.[0]?.id || null,
          idGeneration,
          idVersion,
          purchaseDate: item.date,
          lastOwnershipDate: item.cavSerialization.cavInfo.currOwners[0].date,
        }
      }),
    }
  }

  // Método para enviar múltiples registros
  async submitMultipleChanges () {
    const items = this.stocks.filter(stock => !this.checkItem(stock)?.length)
    if (!items.length) {
      this.loadNotification({
        message: 'No hay registros para importar',
        color: 'warning',
      })
      return
    }
    this.submittingMultiple = true

    try {
      await this.prepareMultipleItems(items)
      const recordData = await this.sendMultipleItems(items)
      this.stockImported = []
      this.existingStock = []
      if (recordData.success.length) {
        await this.handleMultipleImportSuccess(recordData.success)
      }
      if (recordData.errors.length) {
        this.handleMultipleImportError(recordData.errors)
      }
    } catch (error: any) {
      this.handleMultipleImportError(error)
    } finally {
      this.finishMultipleImport()
    }
  }

  async prepareMultipleItems (items) {
    // Procesar cada elemento seleccionado
    for (const item of items) {
      item.loading = true

      // Verificar si la versión ya existe para el año seleccionado
      const versionYearExists = await this.checkVersionYearExists(item)

      if (!versionYearExists) {
        // Si no existe, extenderla desde una versión existente en otro año
        await this.extendVersionToSelectedYear(item)
      }

      // Verificar y asegurar que idVersionYear esté establecido correctamente
      if (item.version && item.version.match && item.version.match.id) {
        item.idVersionYear = item.version.match.id
      }
    }
  }

  async sendMultipleItems (items) {
    // Construir el objeto con todos los registros seleccionados
    const recordData = this.buildRecordData(items)

    console.log('Sending multiple items:', recordData)

    // Actualizar JWT antes de la llamada
    await updateJWT()
    const token = localStorage.getItem('apollo-token')

    // Enviar datos al endpoint
    const response = await axios.post(`${VUE_APP_BASE_URL}/geniofiles/api/stock/upload-records`, recordData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      timeout: 30000,
    })

    console.log('Response:', response)

    return { success: response.data.records, errors: response.data.errors }
  }

  async handleMultipleImportSuccess (recordData) {
    if (!recordData.length) return
    // Mostrar mensaje de éxito
    this.loadNotification({
      message: `${recordData.length} registros importados correctamente`,
      color: 'success',
    })

    // Remover los elementos procesados
    const idsToRemove = recordData.map(item => item.ppu)
    this.stockImported = await this.fetchData({
      query: { name: 'findLite', model: 'Stock' },
      filter: { stock_detail: { auto: { registration_plate: { _in: idsToRemove } } } },
      force: true,
    })
    this.existingStock = []
    this.stocks = this.stocks.filter(item => !idsToRemove.includes(item.ppu))
    this.selectedItems = []

    const importedCount = recordData.length

    if (this.stocks.length === 0) {
      this.importDialogTitle = 'Importación completa'
      this.importDialogText = 'Los vehículos fueron importados correctamente'
      this.importDialogRedirect = true
      this.dialog = false
      this.dialog = true
    } else {
      this.importDialogTitle = 'Importación parcial'
      this.importDialogText = `${importedCount} vehículo(s) importado(s) correctamente`
      this.importDialogRedirect = false
    }
    this.importDialog = true
    this.fillKeys()
  }

  handleMultipleImportError (error) {
    console.error('Error al procesar múltiples cambios:', error)

    // Mostrar mensaje de error
    this.loadNotification({
      message: `Error al importar registros: ${error.map(e => e.ppu).join(', ') || 'Error desconocido'}`,
      color: 'error',
    })

    this.importDialogTitle = 'Error'
    this.importDialogText = 'Error al importar los vehículos'
    this.importDialogRedirect = false
    this.importDialog = true
    this.fillKeys()
  }

  finishMultipleImport () {
    // Desmarcar todos los elementos como cargando
    this.selectedItems.forEach(item => {
      item.loading = false
    })

    this.submittingMultiple = false
  }

  // Método para actualizar la lista de elementos seleccionados
  updateSelectedItems () {
    this.selectedItems = this.stocks.filter(item => item.selected === true)
  }

  // Propiedad computada para contar registros válidos
  get validItemsCount () {
    return this.stocks.filter(item => !this.validateFields(item)).length
  }

  validateFields (item) {
    this.$set(item, 'errorMessages', '')

    // Verificar campos anidados
    this.validateNestedFields(item)

    // Verificar duplicación de llaves
    this.validateKeyDuplication(item)

    // Verificar diferencias con los datos del CAV solo si hay CAV
    if (item.cav && item.cav.length > 0) {
      this.validateCavData(item)
    } else {
      // Limpiar mensajes de error relacionados con CAV si no hay CAV
      item.cavErrorMessages = []
      // Eliminar mensaje de error de CAV si existe
      if (item.errorMessages && item.errorMessages.includes('Diferencias con CAV')) {
        this.$set(item, 'errorMessages', item.errorMessages.replace(', Diferencias con CAV', '').replace('Diferencias con CAV, ', '').replace('Diferencias con CAV', ''))
      }
    }

    // Validar que el precio de lista no sea menor al precio de compra
    this.validatePriceList(item)

    // Validar descuento y bono de renovación (advertencias y errores)
    this.validateDiscount(item)
    this.validateRenewalBonus(item)

    return !!item.errorMessages
  }

  validateNestedFields (item) {
    const nested = [
      { path: ['brand', 'match', 'id'], label: 'Marca' },
      { path: ['model', 'match', 'id'], label: 'Modelo' },
      { path: ['version', 'match', 'id'], label: 'Versión' },
    ]
    nested.forEach(n => {
      let value = item
      n.path.forEach(p => { value = value ? value[p] : undefined })
      if (!value) this.$set(item, 'errorMessages', item.errorMessages + ` ${n.label}. `)
    })
  }

  validateKeyDuplication (item) {
    if (!item?.key) return
    // Primero limpiamos los mensajes de error relacionados con llaves duplicadas en todos los stocks
    this.stocks.forEach(stock => {
      // Limpiar mensajes de error relacionados con llaves duplicadas
      if (stock.keyErrorMessage === 'Llave duplicada') {
        this.$set(stock, 'keyErrorMessage', '')
      }

      if (stock.errorMessages && stock.errorMessages.includes('Llave duplicada')) {
        const newErrorMessage = stock.errorMessages
          .replace(', Llave duplicada', '')
          .replace('Llave duplicada, ', '')
          .replace('Llave duplicada', '')
          .trim()
        this.$set(stock, 'errorMessages', newErrorMessage)
      }
    })

    // Ahora revisamos si hay llaves duplicadas
    // Creamos un mapa para rastrear las llaves y sus ocurrencias
    const keyMap = new Map()

    // Primera pasada: contar ocurrencias de cada llave
    this.stocks.forEach(stock => {
      if (stock.key) {
        const key = String(stock.key)
        if (!keyMap.has(key)) {
          keyMap.set(key, [])
        }
        keyMap.get(key).push(stock)
      }
    })

    // Segunda pasada: marcar las llaves duplicadas
    keyMap.forEach((stocks, key) => {
      if (stocks.length > 1) {
        // Si hay más de un stock con la misma llave, marcarlos todos como duplicados
        stocks.forEach(stock => {
          this.$set(stock, 'keyErrorMessage', 'Llave duplicada')
          this.$set(stock, 'errorMessages',
            stock.errorMessages
              ? `${stock.errorMessages}, Llave duplicada`
              : 'Llave duplicada'
          )
        })
      }
    })
  }

  async setFieldWithCavData (item) {
    if (!item?.cavData) {
      return
    }

    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) {
      return
    }

    if (!this.stocks[index]?.year) {
      const year = this.years.find(year => year.id.toString() === item.cavData.year.toString())
      this.stocks[index].year = year.id
      await this.handleYearChange(item)
    }

    if (!this.stocks[index]?.ppu) {
      this.stocks[index].ppu = item.cavData.ppuCav
      await this.validatePlate(this.stocks[index])
    }

    if (!this.stocks[index].brand?.match) {
      this.stocks[index].brand.match = this.stocks[index].brand.data.find(brand => brand.name === item.cavData.brand)
      await this.handleBrandChange(item)
    }

    if (!this.stocks[index].model?.match) {
      this.stocks[index].model.match = this.stocks[index].model.data.find(model => {
        const modelName = model.name.toLowerCase()
        const cavModelName = item.cavData.model.toLowerCase()
        return modelName === cavModelName || modelName.includes(cavModelName) || cavModelName.includes(modelName)
      }) || null
      if (this.stocks[index].model.match) {
        await this.handleModelChange(item)
      }
    }
  }

  validateCavData (item) {
    if (!item || !item.cavData) {
      return
    }

    // Resetear las diferencias para recalcularlas desde cero
    const cavDifferences = []

    // Validar campos básicos
    this.validateBasicCavFields(item, cavDifferences)

    // Validar modelo y versión
    this.validateModelVersionMatch(item, cavDifferences)

    // Manejar las diferencias encontradas
    if (cavDifferences.length > 0) {
      this.handleCavDifferences(item, cavDifferences)
    } else {
      this.clearCavDifferences(item)
    }
  }

  handleCavDifferences (item, cavDifferences) {
    if (!item.id) {
      return
    }

    this.cavErrorMessages[item.id] = cavDifferences

    // Actualizar también el objeto cavErrorMessages del item para la visualización
    item.cavErrorMessages = [...cavDifferences]

    // Verificar si hay diferencias que no sean de modelo o versión
    const otherDifferences = cavDifferences.filter(diff =>
      !diff.includes('Modelo:') && !diff.includes('Versión:')
    )

    // Solo añadir "Diferencias con CAV" al mensaje de error si hay diferencias que no sean de modelo o versión
    if (otherDifferences.length > 0) {
      // Asegurarnos de que el error de CAV se incluye en los mensajes generales
      if (!item.errorMessages?.includes('Diferencias con CAV')) {
        if (item.errorMessages) {
          item.errorMessages += ', Diferencias con CAV'
        } else {
          item.errorMessages = 'Diferencias con CAV'
        }
      }
    } else {
      // Si solo hay diferencias de modelo o versión, no incluir "Diferencias con CAV" en el mensaje de error
      if (item.errorMessages?.includes('Diferencias con CAV')) {
        item.errorMessages = item.errorMessages
          .replace(', Diferencias con CAV', '')
          .replace('Diferencias con CAV, ', '')
          .replace('Diferencias con CAV', '')
          .trim()
      }
    }
  }

  clearCavDifferences (item) {
    if (!item.id) return

    delete this.cavErrorMessages[item.id]

    // Limpiar también los errores en el objeto del item
    item.cavErrorMessages = []

    // Eliminar mensaje de error de CAV si existe
    if (item.errorMessages && item.errorMessages.includes('Diferencias con CAV')) {
      item.errorMessages = item.errorMessages
        .replace(', Diferencias con CAV', '')
        .replace('Diferencias con CAV, ', '')
        .replace('Diferencias con CAV', '')
        .trim()

      // Si después de reemplazar no queda nada, asignar cadena vacía
      if (item.errorMessages === '') {
        item.errorMessages = ''
      }
    }
  }

  validateBasicCavFields (item, cavDifferences) {
    if (!item.cavData) {
      return
    }

    // Extracción más robusta de valores de marca
    let currentBrandName = ''
    let currentBrandObject = null

    // Verificamos si hay una marca seleccionada y la extraemos correctamente
    if (item.brand && item.brand.match) {
      currentBrandObject = item.brand.match
      currentBrandName = (currentBrandObject.name || '').toLowerCase()
    }

    const cavBrand = item.cavData.brand?.toLowerCase() || ''

    // Verificar diferencias de marca
    if (cavBrand) {
      if (!currentBrandName) {
        // No hay marca seleccionada pero hay marca en CAV
        cavDifferences.push(`Marca: CAV=${item.cavData.brand.toUpperCase()}, Actual=No seleccionada`)
      } else if (currentBrandName !== cavBrand) {
        // Hay marca seleccionada pero es diferente a la del CAV
        cavDifferences.push(`Marca: CAV=${item.cavData.brand.toUpperCase()}, Actual=${currentBrandObject.name.toUpperCase()}`)
      }
    }

    // Validar año - Corregido para comparar correctamente
    if (item.cavData.year && (!item.year ||
      (item.year && item.cavData.year && item.year.toString() !== item.cavData.year.toString()))) {
      cavDifferences.push(`Año: CAV=${item.cavData.year}, Actual=${item.year || 'No seleccionado'}`)
    }

    // Validar patente
    const cavPatente = item.cavData.ppuCav || item.cavData.patent
    if (cavPatente && (!item.ppu || (item.ppu && cavPatente.toUpperCase() !== item.ppu.toUpperCase()))) {
      cavDifferences.push(`Patente: CAV=${cavPatente.toUpperCase()}, Actual=${item.ppu?.toUpperCase() || 'No seleccionada'}`)
    }
  }

  validateModelVersionMatch (item, cavDifferences) {
    // Verificar si hay datos para comparar
    if (!item.cavData || (!item.cavData.model && !item.cavData.version)) {
      return
    }

    // Extraer nombres para comparación
    const modelName = item.model?.match?.name?.toLowerCase() || ''
    const versionName = item.version?.match?.version?.name?.toLowerCase() || ''
    const cavModelName = item.cavData.model?.toLowerCase() || ''
    const cavVersionName = item.cavData.version?.toLowerCase() || ''

    // Si no hay modelo seleccionado pero hay modelo en CAV
    if (cavModelName && !modelName) {
      cavDifferences.push(`Modelo: CAV=${item.cavData.model.toUpperCase()}, Actual=No seleccionado`)
      return
    }

    // Verificar si el modelo seleccionado está contenido en el modelo CAV
    if (modelName && cavModelName && cavModelName.includes(modelName)) {
      // Extraer la parte del modelo CAV que no coincide con el modelo seleccionado
      // Esta sería potencialmente la versión
      const remainingPart = cavModelName.replace(modelName, '').trim()

      // Si hay una parte restante y no hay versión seleccionada
      if (remainingPart && !versionName) {
        cavDifferences.push(`Versión: CAV=${remainingPart.toUpperCase()}, Actual=No seleccionada`)
      } else if (remainingPart && versionName && !versionName.includes(remainingPart) && !remainingPart.includes(versionName)) {
        // Si hay una parte restante y una versión seleccionada que no coincide
        cavDifferences.push(`Versión: CAV=${remainingPart.toUpperCase()}, Actual=${item.version.match.version.name.toUpperCase()}`)
      }

      // No añadimos diferencia en el modelo ya que el modelo seleccionado está contenido en el CAV
      return
    }

    // Si hay versión en CAV pero no hay versión seleccionada
    if (cavVersionName && !versionName) {
      cavDifferences.push(`Versión: CAV=${item.cavData.version.toUpperCase()}, Actual=No seleccionada`)
    }

    // Solo hacemos las comparaciones adicionales si hay valores seleccionados
    if (modelName && cavModelName) {
      this.validateModelVersionDetails(item, cavDifferences, modelName, versionName, cavModelName, cavVersionName)
    }
  }

  validateModelVersionDetails (item, cavDifferences, modelName, versionName, cavModelName, cavVersionName) {
    // Verificar si tenemos datos para modelo y versión
    const hasModelData = true
    const hasVersionData = versionName && cavVersionName

    // Comprobar si el modelo está incluido en la versión (o viceversa)
    let versionIncludesModel = false
    if (modelName && versionName) {
      versionIncludesModel = versionName.includes(modelName) || modelName.includes(versionName)
    }

    // Verificar si hay coincidencia parcial entre CAV modelo y los datos seleccionados
    const modelHasPartialMatch = cavModelName.includes(modelName) || modelName.includes(cavModelName)
    const versionHasPartialMatch = hasVersionData && (cavVersionName.includes(versionName) || versionName.includes(cavVersionName))

    // Verificar si hay coincidencia cruzada (modelo en versión o versión en modelo)
    const modelInCavVersion = modelName && cavVersionName && cavVersionName.includes(modelName)
    const versionInCavModel = versionName && cavModelName && cavModelName.includes(versionName)

    // Lógica para decidir qué diferencias mostrar
    if (hasModelData && !modelHasPartialMatch && !modelInCavVersion && !versionIncludesModel) {
      cavDifferences.push(`Modelo: CAV=${item.cavData.model.toUpperCase()}, Actual=${item.model.match.name.toUpperCase()}`)
    }

    if (hasVersionData && !versionHasPartialMatch && !versionInCavModel && !versionIncludesModel) {
      cavDifferences.push(`Versión: CAV=${item.cavData.version.toUpperCase()}, Actual=${item.version.match.version.name.toUpperCase()}`)
    }
  }

  async handleBrandChange (item) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return
    // Almacenar temporalmente los datos CAV
    const cavData = item.cavData

    // Limpiar modelo y versión cuando cambia la marca
    this.$set(this.stocks[index], 'model', { match: null, data: [] })
    this.$set(this.stocks[index], 'version', { match: null, data: [] })

    // Restaurar los datos CAV para que estén disponibles para la validación
    this.$set(this.stocks[index], 'cavData', cavData)

    // Buscar modelos para la nueva marca
    if (this.stocks[index].brand && this.stocks[index].brand.match && this.stocks[index].year) {
      await this.fetchModels(this.stocks[index])
    }

    // Limpiar mensajes de error
    if (this.stocks[index].id) {
      this.modelErrorMessages[this.stocks[index].id] = ''
      this.versionErrorMessages[this.stocks[index].id] = ''
    }

    // Forzar la limpieza de cualquier mensaje de error existente relacionado con CAV
    if (this.stocks[index].id && this.cavErrorMessages[this.stocks[index].id]) {
      delete this.cavErrorMessages[this.stocks[index].id]
      this.$set(this.stocks[index], 'cavErrorMessages', [])
    }

    // Validar campos y datos CAV inmediatamente
    this.validateFields(this.stocks[index])
    this.validateCavData(this.stocks[index])

    // También validar después del siguiente tick para asegurar que todos los datos estén actualizados
    this.$nextTick(() => {
      this.validateFields(this.stocks[index])
      this.validateCavData(this.stocks[index])
    })
  }

  async handleModelChange (item) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return

    // Almacenar temporalmente los datos CAV
    const cavData = this.stocks[index].cavData

    // Limpiar versión cuando cambia el modelo
    this.$set(this.stocks[index], 'version', { match: null, data: [] })

    // Limpiar idGeneration e idVersionYear ya que cambiamos de modelo
    this.$set(this.stocks[index], 'idGeneration', null)
    this.$set(this.stocks[index], 'idVersionYear', null)

    // Restaurar los datos CAV para que estén disponibles para la validación
    this.$set(this.stocks[index], 'cavData', cavData)

    // Buscar versiones para el nuevo modelo
    if (this.stocks[index].model && this.stocks[index].model.match && this.stocks[index].year) {
      await this.fetchVersions(this.stocks[index])
    }

    // Limpiar mensajes de error
    if (this.stocks[index].id) {
      this.versionErrorMessages[this.stocks[index].id] = ''
    }

    // Validar campos y datos CAV
    this.validateFields(this.stocks[index])
    this.validateCavData(this.stocks[index])

    this.$nextTick(() => {
      this.validateFields(this.stocks[index])
      this.validateCavData(this.stocks[index])
    })
  }

  handleVersionChange (item) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return
    // No necesitamos limpiar ningún campo aquí

    // Importante: forzar la actualización de atributos estableciendo checkAttributes a true
    this.$nextTick(() => {
      // Limpiar idGeneration para evitar referencias incorrectas a generaciones de otras versiones
      this.$set(this.stocks[index], 'idGeneration', null)

      // Actualizar idVersionYear con el nuevo ID de versión
      if (this.stocks[index].version?.match?.id) {
        this.$set(this.stocks[index], 'idVersionYear', this.stocks[index].version.match.id)
      }

      this.$set(this.stocks[index], 'version', item.version)
      // Activar la actualización de atributos
      this.$set(this.stocks[index], 'checkAttributes', true)
    })

    // Validar campos y datos CAV
    this.validateFields(this.stocks[index])
    this.validateCavData(this.stocks[index])

    this.$nextTick(() => {
      this.validateFields(this.stocks[index])
      this.validateCavData(this.stocks[index])
    })
  }

  async handleYearChange (item) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return

    // Almacenar temporalmente los datos CAV
    const cavData = this.stocks[index].cavData

    // Limpiar marca, modelo y versión cuando cambia el año
    this.$set(this.stocks[index], 'brand', { match: null, data: [] })
    this.$set(this.stocks[index], 'model', { match: null, data: [] })
    this.$set(this.stocks[index], 'version', { match: null, data: [] })

    // Limpiar idGeneration e idVersionYear ya que cambiamos de año
    this.$set(this.stocks[index], 'idGeneration', null)
    this.$set(this.stocks[index], 'idVersionYear', null)

    // Restaurar los datos CAV para que estén disponibles para la validación
    this.$set(this.stocks[index], 'cavData', cavData)

    // Limpiar mensajes de error
    if (this.stocks[index].id) {
      this.brandErrorMessages[this.stocks[index].id] = ''
      this.modelErrorMessages[this.stocks[index].id] = ''
      this.versionErrorMessages[this.stocks[index].id] = ''
    }

    // Cargar las marcas disponibles para el nuevo año
    if (this.stocks[index].year) {
      await this.fetchBrands(this.stocks[index])
    }

    // Validar campos y datos CAV
    this.validateFields(this.stocks[index])
    this.validateCavData(this.stocks[index])

    this.$nextTick(() => {
      this.validateFields(this.stocks[index])
      this.validateCavData(this.stocks[index])
    })
  }

  openCreateVersionDialog (item) {
    this.currentItem = item
    // Asegurarse de que la versión sugerida se obtenga correctamente
    this.suggestedVersion = ''

    if (item.cavData?.version) {
      this.suggestedVersion = item.cavData.version
    } else if (item.cavErrorMessages && item.cavErrorMessages.some(msg => msg.includes('Versión:'))) {
      // Extraer la versión de los mensajes de error si está disponible
      const versionMessage = item.cavErrorMessages.find(msg => msg.includes('Versión:'))
      if (versionMessage) {
        const versionMatch = versionMessage.match(/CAV=([^,]+)/)
        if (versionMatch && versionMatch[1]) {
          this.suggestedVersion = versionMatch[1].trim()
        }
      }
    }
    this.showCreateVersionDialog = true
  }

  onVersionCreated (data) {
    // Actualizar el item actual con la versión recién creada
    if (this.currentItem) {
      if (data.version && data.versionYear) {
        // Si recibimos tanto la versión como el VersionYear desde el componente
        this.updateItemWithVersionYear(this.currentItem, data.versionYear, data.version)

        // La versión es nueva, por lo que no tiene generaciones - limpiar idGeneration
        this.currentItem.idGeneration = null

        // Forzar la actualización de atributos
        this.currentItem.checkAttributes = true
      } else {
        // Mantener compatibilidad con la versión anterior
        this.fetchVersionYear(this.currentItem, data)
      }
    }
  }

  updateItemWithVersionYear (item, versionYear, version) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return

    // Verificar si los datos de dataTableData para este item existen
    if (!this.dataTableData[item.id]) {
      this.dataTableData[item.id] = {}
    }

    // Asegurarse de que version.data existe
    if (!this.stocks[index].version.data) {
      this.stocks[index].version.data = []
    }

    // Agregar la versión encontrada a las versiones disponibles
    if (!this.stocks[index].version.data.some(v => v.id === versionYear.id)) {
      this.stocks[index].version.data.push(versionYear)
    }

    // Actualizar la versión seleccionada en el item usando Vue.set para garantizar reactividad
    this.$set(this.stocks[index].version, 'match', versionYear)
    this.$set(this.stocks[index], 'idVersionYear', versionYear.id)

    // Limpiar idGeneration ya que la versión es nueva y no tiene generaciones
    this.$set(this.stocks[index], 'idGeneration', null)

    // Actualizar también en dataTableData para mantener la consistencia
    if (!this.dataTableData[item.id].version) {
      this.$set(this.dataTableData[item.id], 'version', { data: [], match: null })
    }

    if (!this.dataTableData[item.id].version.data) {
      this.$set(this.dataTableData[item.id].version, 'data', [])
    }

    // Agregar a dataTableData si no existe
    if (!this.dataTableData[item.id].version.data.some(v => v.id === versionYear.id)) {
      this.dataTableData[item.id].version.data.push(versionYear)
    }

    this.$set(this.dataTableData[item.id].version, 'match', versionYear)

    // También actualizar en dataTableData
    this.$set(this.dataTableData[item.id], 'idVersionYear', versionYear.id)
    this.$set(this.dataTableData[item.id], 'idGeneration', null)

    // Forzar el evento checkAttributes para que se actualicen los atributos
    this.$set(this.stocks[index], 'checkAttributes', true)
  }

  async fetchVersionYear (item, version) {
    // Obtener los datos de VersionYear para el año específico
    const versionYearData = await this.fetchData({
      query: {
        name: 'findLite',
        model: 'VersionYear',
      },
      filter: {
        _and: [
          { id_version: { _eq: version.id } },
          { id_year: { _eq: item.year } },
        ],
      },
      force: true,
    })

    if (versionYearData && versionYearData.length > 0) {
      this.updateItemWithVersionYear(item, versionYearData[0], version)
    }
  }

  // Propiedades computadas para pasar al componente CreateVersion
  get currentItemModel () {
    return this.currentItem?.model?.match || null
  }

  get currentItemBrand () {
    return this.currentItem?.brand?.match || null
  }

  get currentItemYear () {
    return this.currentItem?.year || null
  }

  get currentItemCavData () {
    return this.currentItem?.cavData || null
  }

  get versions () {
    const modelId = this.currentItemModel?.id
    if (!modelId) return []

    // Crear un array con todas las versiones disponibles para este modelo
    return this.stocks
      .filter(stock => stock.version?.data?.length && stock.model?.match?.id === modelId)
      .flatMap(stock => stock.version.data)
      .filter((v, i, self) => i === self.findIndex(t => t.version?.name === v.version?.name && t.id === v.id))
      .map(v => v.version)
  }

  getMileageWarningMessage (item) {
    if (!item.mileage) {
      return 'Campo requerido'
    }

    const digits = String(item.mileage).length

    if (digits < 4) {
      return 'Precaución: bajo kilometraje'
    } else if (digits > 5) {
      return 'Precaución: mucho kilometraje'
    }

    return ''
  }

  // Función para verificar si hay errores relacionados con CAV
  hasCavErrors (item) {
    return item.cavErrorMessages && item.cavErrorMessages.length > 0
  }

  @Watch('stocks', { deep: false, immediate: false })
  async updateFields (newVal) {
    for (const item of this.stocks) {
      // Si el CAV cambió, resetear los datos y procesarlos de nuevo
      if (item.cavId !== item?.cav?.[0]?.id) {
        await this.updateSingleItem(item)
      }
    }
  }

  @Watch('stocks', { deep: true })
  onStocksChanged () {
    localStorage.setItem('importStocks_data', JSON.stringify({
      stocks: this.stocks,
      allRecords: this.allRecords,
      existingRecords: this.existingRecords,
      total: this.total,
      totalAnalyzed: this.totalAnalyzed,
      filteredOutPlates: this.filteredOutPlates,
      dataTableData: this.dataTableData,
    }))
  }

  async findCavPerson (owner) {
    return this.fetchData({
      query: { name: 'find', model: 'Person' },
      filter: { uid: { _ilike: `%${owner.rutClean}%` } },
      force: true,
    })
  }

  async createPerson (owner) {
    const fields: any = {
      uid: owner.rutClean,
    }

    if (owner.isNaturalPerson) {
      // Agregar campos para personas naturales
      fields.first_name = owner.firstName
      fields.second_name = owner.secondName
      fields.surname = owner.surname
      fields.name_person_type = 'natural_person'
      fields.second_surname = owner.secondSurname
    } else if (owner.isCompany) {
      // Agregar campos para empresas
      fields.alias = owner.alias
      fields.name_person_type = 'company'
      fields.company_name = owner.companyName
    }

    return this.pushData({
      model: 'Person',
      fields,
    })
  }

  // handleStocksChanges eliminado

  checkDuplicateKeys () {
    // Resetear todos los mensajes de error de llaves
    this.stocks.forEach(item => {
      const hasKeyDuplicate = this.hasDuplicateKey(item)

      if (hasKeyDuplicate) {
        item.keyErrorMessage = 'Llave duplicada'
        if (item.errorMessages && !item.errorMessages.includes('Llave duplicada')) {
          item.errorMessages += `${!item?.errorMessages?.length ? '' : ', '} Llave duplicada`
        } else if (!item.errorMessages) {
          item.errorMessages = 'Llave duplicada'
        }
      } else {
        // Si antes tenía error de llave duplicada, eliminarlo del mensaje de errores
        if (item.keyErrorMessage === 'Llave duplicada') {
          item.keyErrorMessage = ''
          if (item.errorMessages && item.errorMessages.includes('Llave duplicada')) {
            item.errorMessages = item.errorMessages.replace(', Llave duplicada', '').replace('Llave duplicada, ', '').replace('Llave duplicada', '')
          }
        }
      }
    })
  }

  // Método auxiliar para verificar si un item tiene llave duplicada
  hasDuplicateKey (item) {
    return this.stocks.some(
      stockItem => stockItem.id !== item.id &&
        stockItem.key &&
        item.key &&
        stockItem.key.toString() === item.key.toString()
    )
  }

  // Método para manejar el cambio del archivo CAV
  async onCavFileChange (item) {
    // Esperar a que la ref del archivo esté disponible
    if (!item.cav || !item.cav.length) return

    // Forzar la actualización de CAV
    item.cavId = null

    // Refrescar los datos manualmente
    await this.updateSingleItem(item)
  }

  cavWithOutSerialization (item) {
    item = null
    this.loadNotification({
      message: 'No se pudo leer el CAV intente nuevamente',
      color: 'error',
    })
  }

  initializeStockItem (index, item) {
      this.$set(this.stocks[index], 'owner', [])
      this.$set(this.stocks[index], 'owners', null)
      this.$set(this.stocks[index], 'uid', [])
      this.$set(this.stocks[index], 'personType', [])
      this.$set(this.stocks[index], 'cavData', null)
      this.$set(this.stocks[index], 'cavErrorMessages', [])
      this.$set(this.stocks[index], 'cavId', item?.cav?.[0]?.id)
  }

  // Método para actualizar un solo item sin esperar al watcher
  async updateSingleItem (item) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return
    if (this.stocks[index].cavId !== item?.cav?.[0]?.id) {
      this.initializeStockItem(index, item)
      if (item?.cav?.[0]?.id) {
        const fileInfo = await this.fetchData({
          query: { name: 'fetch', model: 'File', params: { id: item?.cav?.[0].id } },
          force: true,
        })

        const isSerialization = 'serialization' in fileInfo && fileInfo?.serialization

        if (!isSerialization) {
          return this.cavWithOutSerialization(this.stocks[index])
        }
        const isCavInfo = 'cavInfo' in isSerialization && isSerialization?.cavInfo

        const carData = 'carData' in isCavInfo && isCavInfo.carData
        // Guardar los datos del carData para validaciones
        if (carData) {
          this.$set(this.stocks[index], 'cavSerialization', isSerialization)
          this.$set(this.stocks[index], 'cavData', carData)
          // Validar inmediatamente después de cargar los datos del CAV
          await this.setFieldWithCavData(this.stocks[index])
          this.validateCavData(this.stocks[index])
        }

        const currOwners = 'currOwners' in isCavInfo && isCavInfo.currOwners

        this.stocks[index].owners = isCavInfo?.prevOwners?.length ? isCavInfo?.prevOwners?.length + 1 : 1
        if (currOwners) {
          await Promise.all(
            currOwners.map(async (owner: CavCurrOwners) => {
              let person = null
              // Buscar si la persona ya existe
              const existingPersons = await this.findCavPerson(owner)

              if (existingPersons && existingPersons.length) {
                // Si existe, retornar la persona existente
                person = existingPersons[0]
              } else {
                // Si no existe, crear una nueva persona
                person = await this.createPerson(owner)
              }
              this.stocks[index].owner.push(person.fullName)
              this.stocks[index].uid.push(person.uid)
              this.stocks[index].personType.push(person.type.description)
            }),
          )
        }
      }
    }
  }

  validatePriceList (item) {
    if (item.priceList && item.purchasePrice && parseFloat(item.priceList) < parseFloat(item.purchasePrice)) {
      this.$set(item, 'priceListErrorMessage', 'Advertencia: Precio de lista menor al precio de compra')
      this.$set(item, 'errorMessages', `${item.errorMessages ? item.errorMessages + ', ' : ''}Precio de lista menor al precio de compra`)
    } else {
      this.$set(item, 'priceListErrorMessage', '')
      if (item.errorMessages && item.errorMessages.includes('Precio de lista menor al precio de compra')) {
        this.$set(item, 'errorMessages', item.errorMessages.replace(/,? Precio de lista menor al precio de compra/, '').trim())
      }
    }
  }

  getPriceListErrorMessage (item) {
    if (!item.priceList) {
      return 'Campo requerido'
    }
    return item.priceListErrorMessage || ''
  }

  async fetchBrands (item) {
    // Obtener las marcas disponibles para este año
    const brands = await this.fetchData({
      query: { name: 'findLite', model: 'Brand', order: { name: 'asc' } },
      filter: {
        models: {
          versions: {
            years: {
              id_year: {
                _gte: parseToNumber(item.year) - parseToNumber(this.maxVehicleAgeAllowed),
                _lte: parseToNumber(item.year) + parseToNumber(this.maxVehicleAgeAllowed),
              },
            },
          },
        },
      },
      force: true,
    })

    // Actualizar las marcas en el item y en dataTableData
    if (item.id && this.dataTableData[item.id]) {
      item.brand.data = brands
      this.dataTableData[item.id].brand.data = _.cloneDeep(brands)
    } else {
      item.brand.data = brands
    }
  }

  // Filtrar las diferencias de CAV para la primera columna, excluyendo las de modelo y versión
  filteredCavDifferences (item) {
    if (!item.cavErrorMessages || !item.cavErrorMessages.length) return []
    // Filtramos las diferencias que NO contengan "Modelo:" o "Versión:"
    return item.cavErrorMessages.filter(diff =>
      !diff.includes('Modelo:') && !diff.includes('Versión:')
    )
  }

  copyToClipboardAndNotify (text, tipo) {
    // Copiar al portapapeles
    navigator.clipboard.writeText(text)
      .then(() => {
        // Notificar al usuario
        this.loadNotification({
          message: `Valor de ${tipo} CAV copiado: ${text}`,
          color: 'success',
        })
      })
      .catch(err => {
        console.error('Error al copiar al portapapeles:', err)
        this.loadNotification({
          message: `No se pudo copiar el valor de ${tipo} CAV`,
          color: 'error',
        })
      })
  }

  copyToClipboardVersion (item) {
    // Extraer el valor correcto según la fuente
    let versionText = ''

    if (item.cavErrorMessages && item.cavErrorMessages.some(msg => msg.includes('Versión:'))) {
      // Si hay un mensaje de error específico para versión, extraer el valor
      const versionMsg = item.cavErrorMessages.find(msg => msg.includes('Versión:'))
      versionText = versionMsg?.split('CAV=')[1]?.split(',')[0] || ''
    } else if (item.cavData && item.cavData.version) {
      // Si no hay mensaje pero hay version en cavData
      versionText = item.cavData.version
    }

    if (versionText) {
      this.copyToClipboardAndNotify(versionText, 'versión')
    }
  }

  copyDifferenceToClipboard (diff) {
    try {
      const cavMatch = diff.match(/CAV=([^,]+)/)
      if (cavMatch && cavMatch[1]) {
        const cavValue = cavMatch[1]
        navigator.clipboard.writeText(cavValue).then(() => {
          this.loadNotification({
            message: `CAV "${cavValue}" copiado al portapapeles`,
            color: 'success',
          })
        }).catch(err => {
          console.error('Error al copiar al portapapeles:', err)
          this.loadNotification({
            message: 'Error al copiar al portapapeles',
            color: 'error',
          })
        })
      } else {
        this.loadNotification({
          message: 'No se encontró valor CAV para copiar',
          color: 'warning',
        })
      }
    } catch (error) {
      console.error('Error en copyDifferenceToClipboard:', error)
      this.loadNotification({
        message: 'Error al procesar la diferencia',
        color: 'error',
      })
    }
  }

  setField (item: any, field: string, value: any) {
    const index = this.stocks.findIndex(s => s.id === item.id)
    if (index === -1) return
    this.$set(this.stocks[index], field, value)
    if (field === 'cav') {
      this.onCavFileChange(item)
    }
    // Revalidar el item tras el cambio de campo
    this.validateFields(this.stocks[index])
    this.validateCavData(this.stocks[index])
  }

  /**
   * Valida si una patente ya existe en el sistema al perder foco.
   */
  async validatePlate (item: any) {
    const plate = item.ppu?.toUpperCase()
    if (!plate || plate?.length < 6) return

    // Usar cache o consultar si no existe
    if (!(plate in this.plateExistsCache)) {
      const result = await this.fetchData({
        query: { name: 'find', model: 'Auto' },
        filter: {
          _and: [
          { process_status: { status: { name: { _nin: ['deprecated', 'retired', 'sold', 'not_match'] } } } },
          { registration_plate: { _eq: plate } },
          ],
        },
        limit: 1000,
        force: true,
      })

      if (Array.isArray(result) && result.length > 0) {
        this.existingRecords = result.length
        this.total = this.stocks.length - this.existingRecords

        // Guardar el estado del vehículo junto con la información de que existe
        this.plateExistsCache[plate] = {
          exists: true,
          status: result[0]?.status?.description,
        }

        this.existingStock = [{
          ppu: result[0].ppu,
          year: result[0].year,
          status: result[0]?.status?.description,
          brand: result[0].version.version.model.brand.name,
          model: result[0].version.version.model.name,
          version: result[0].version.version.name,
        }]
        this.removePPU = true
      } else {
        this.plateExistsCache[plate] = { exists: false }
      }
    }

    // Actualizar mensajes de error según el resultado
    if (this.plateExistsCache[plate].exists) {
      if (!item.errorMessages?.includes('Patente ya existe')) {
        item.errorMessages = item.errorMessages
          ? item.errorMessages + ', Patente ya existe'
          : 'Patente ya existe'
      }

      // Guardar referencia al item actual con error de patente para limpiarlo después
      this.currentItemWithPlateError = item

      // Mostrar diálogo de patente existente con el estado
      this.importDialogTitle = 'Patente existente'
      this.importDialogText = `La patente "${plate}" ya existe en el sistema con estado: ${this.plateExistsCache[plate].status}`
      this.importDialogRedirect = false
      this.importDialog = true
      this.fillKeys()
    } else {
      if (item.errorMessages?.includes('Patente ya existe')) {
        item.errorMessages = item.errorMessages
          .replace(', Patente ya existe', '')
          .replace('Patente ya existe', '')
          .trim()
      }
    }

    this.validateFields(item)
  }

  // Método para cerrar diálogo y limpiar patente si es necesario
  closeImportDialog () {
    this.importDialog = false
    this.stockImported = []
    if (this.removePPU) {
      this.removePPU = false
      const index = this.stocks.findIndex(s => s.id === this.currentItemWithPlateError.id)
      if (index !== -1) {
        this.stocks[index].ppu = ''
      }

      delete this.plateExistsCache[this.currentItemWithPlateError.ppu]
    }

    // Limpiar el campo de patente si el error fue por patente duplicada
    if (this.importDialogTitle === 'Patente existente' && this.currentItemWithPlateError) {
      this.currentItemWithPlateError.ppu = ''

      // Limpiar mensajes de error relacionados con la patente
      if (this.currentItemWithPlateError.errorMessages?.includes('Patente ya existe')) {
        this.currentItemWithPlateError.errorMessages = this.currentItemWithPlateError.errorMessages
          .replace(', Patente ya existe', '')
          .replace('Patente ya existe', '')
          .trim()
      }

      // Volver a validar el campo
      this.validateFields(this.currentItemWithPlateError)

      // Resetear la referencia
      this.currentItemWithPlateError = null
    }

    if (this.stocks.length === 0) {
      this.file = null
      this.dialog = false
      this.dialog = true
    }

    this.allRecords = this.stocks.length
    this.total = this.stocks.length
    this.existingRecords = 0
  }

  parseDate (dateString) {
    if (!dateString) return null
    const formats = ['YYYY-MM-DD', 'DD/MM/YYYY', 'D/M/YYYY', 'D/MM/YYYY', 'DD/M/YYYY']

    for (const format of formats) {
      const parsedDate = dayjs(dateString, format, true)
      if (parsedDate.isValid()) {
        // Retornar en formato DD/MM/YYYY para mantener consistencia
        return parsedDate.format('DD/MM/YYYY')
      }
    }

    return null
  }

  // Añadir después del método handleData
  normalizeDate (dateString) {
    if (!dateString) return null

    // Probar diferentes formatos de fecha
    const formats = ['YYYY-MM-DD', 'DD/MM/YYYY', 'D/M/YYYY', 'D/MM/YYYY', 'DD/M/YYYY']

    for (const format of formats) {
      const parsedDate = dayjs(dateString, format, true)
      if (parsedDate.isValid()) {
        // Retornar en formato DD/MM/YYYY para mantener consistencia
        return parsedDate.format('DD/MM/YYYY')
      }
    }

    // Verificar si es un string de 8 dígitos
    const eightDigitsRegex = /^\d{8}$/
    if (eightDigitsRegex.test(dateString)) {
      const day = dateString.toString().substring(0, 2)
      const month = dateString.toString().substring(2, 4)
      const year = dateString.toString().substring(4, 8)
      return this.parseDate(`${day}/${month}/${year}`)
    }

    // Si ningún formato coincide, intentar parsear automáticamente
    const autoDate = dayjs(dateString)
    if (autoDate.isValid()) {
      return autoDate.format('DD/MM/YYYY')
    }

    // Si no se pudo parsear, retornar null
    return null
  }

  confirmCancel () {
    this.cancelDialog = true
  }

  closeCancelDialog () {
    this.cancelDialog = false
  }

  cancelSelection () {
    this.cancelDialog = false

    this.selectedRecords.forEach(item => {
      this.removeRecord(item)
    })
    this.total = this.stocks.length
    this.selectedRecords = []

    if (!this.stocks.length) {
      this.dialog = false
      this.dialog = true
    }
  }

  addNewRecord () {
    this.currentItem = null
    this.cleanForm = true
    this.showAddRecordDialog = true
  }

  onRecordCreated (formData) {
    if (!formData) return
    // Mostrar notificación
    this.loadNotification({
      message: 'Registro agregado correctamente',
      color: 'success',
    })

    const index = this.stocks.findIndex(s => s.id === formData.id)
    if (index !== -1) {
      this.stocks.splice(index, 1)
    }
    this.editRecordData = null
  }

  // Método para manejar el caso cuando se hace clic en "Importar manualmente" desde el diálogo
  importManually () {
    this.dialog = false
    this.showAddRecordDialog = true
  }

  // Métodos para manejo de selección personalizada
  isSelected (item: any): boolean {
    return this.selectedRecords.some(selectedItem => selectedItem.id === item.id)
  }

  toggleSelection (item: any): void {
    const index = this.selectedRecords.findIndex(selectedItem => selectedItem.id === item.id)
    if (index === -1) {
      // Si no está seleccionado, agregarlo
      this.selectedRecords.push(item)
    } else {
      // Si ya está seleccionado, quitarlo
      this.selectedRecords.splice(index, 1)
    }
    // Actualizar la lista de elementos seleccionados para funciones de importación
    this.updateSelectedItems()
  }

  get someToImport () {
    // Devuelve true si existe al menos un elemento válido para importar (sin errores)
    return this.stocks.every(stock => this.checkItem(stock).length > 0)
  }

  validateDiscount (item) {
    // Limpiar mensajes previos
    item.discountErrorMessage = ''
    item.discountWarningMessage = ''

    // Si no hay descuento, no validar
    if (!item.discount) return

    // Validar que no sea mayor o igual al precio de lista
    if (item.priceList && parseFloat(item.discount) >= parseFloat(item.priceList)) {
      item.discountErrorMessage = 'El descuento no puede ser igual o mayor al precio de lista'
      if (!item.errorMessages.includes('Descuento mayor o igual al precio de lista')) {
        item.errorMessages += `${!item?.errorMessages?.length ? '' : ', '}Descuento mayor o igual al precio de lista`
      }
    } else {
      if (item.errorMessages && item.errorMessages.includes('Descuento mayor o igual al precio de lista')) {
        item.errorMessages = item.errorMessages.replace(', Descuento mayor o igual al precio de lista', '').replace('Descuento mayor o igual al precio de lista, ', '').replace('Descuento mayor o igual al precio de lista', '').trim()
      }
    }
    // Advertencia si el descuento es alto (por ejemplo, más del 10% del precio de lista)
    if (item.priceList && parseFloat(item.discount) >= 0.1 * parseFloat(item.priceList)) {
      item.discountWarningMessage = 'Precaución: el descuento es alto en relación al precio de lista'
    }
  }

  validateRenewalBonus (item) {
    // Limpiar mensajes previos
    item.renewalBonusErrorMessage = ''
    item.renewalBonusWarningMessage = ''

    // Si no hay bono de renovación, no validar
    if (!item.renewalBonus) return

    // Validar que no sea mayor o igual al precio de lista
    if (item.priceList && parseFloat(item.renewalBonus) >= parseFloat(item.priceList)) {
      item.renewalBonusErrorMessage = 'El bono de renovación no puede ser igual o mayor al precio de lista'
      if (!item.errorMessages.includes('Bono de renovación igual o mayor al precio de lista')) {
        item.errorMessages += `${!item?.errorMessages?.length ? '' : ', '}Bono de renovación igual o mayor al precio de lista`
      }
      return
    } else {
      if (item.errorMessages && item.errorMessages.includes('Bono de renovación igual o mayor al precio de lista')) {
        item.errorMessages = item.errorMessages.replace(', Bono de renovación igual o mayor al precio de lista', '').replace('Bono de renovación igual o mayor al precio de lista, ', '').replace('Bono de renovación igual o mayor al precio de lista', '').trim()
      }
    }
    // Advertencia si el bono es menor o igual al descuento
    if (item.discount && parseFloat(item.renewalBonus) < parseFloat(item.discount)) {
      item.renewalBonusWarningMessage = 'El bono de renovación debería ser mayor o igual al descuento'
    }
  }

  getRenewalBonusErrorMessage (item) {
    return item.renewalBonusErrorMessage || ''
  }

  onSelectErrors (value: boolean) {
    if (value) {
      this.selectedRecords = this.stocks.filter(item => this.checkItem(item).length > 0)
    } else {
      this.selectedRecords = []
    }
  }

  @Watch('stocks', { deep: true, immediate: true })
  onStocksChange (newVal) {
    for (const stock of newVal) {
      const index = this.stocks.findIndex(s => s.id === stock.id)
      if (isValidNumber(stock.key) && index !== -1 && this.stocks[index].keyErrorMessage !== 'Llave duplicada' && this.keys.some(key => parseToNumber(stock.key) === key)) {
          this.stocks[index].keyErrorMessage = 'Llave duplicada'
      }
    }
    this.tdKey += 1
  }

  checkItem (item) {
    // Campos requeridos a validar
    const fields = [
      { key: 'ppu', label: 'Patente' },
      { key: 'year', label: 'Año' },
      { key: 'owner', label: 'Propietario' },
      { key: 'date', label: 'Fecha de compra' },
      { key: 'purchasePrice', label: 'Precio de compra' },
      { key: 'priceList', label: 'Precio de lista' },
      { key: 'generation', label: 'Código SII' },
      { key: 'mileage', label: 'Kilometraje' },
      { key: 'owners', label: 'N° Dueños' },
      { key: 'personType', label: 'Tipo de persona' },
      { key: 'uid', label: 'RUT' },
      { key: 'acquisitionType', label: 'Tipo de adquisición' },
      { key: 'renewalBonus', label: 'Bono de renovación' },
    ]

    // Obtener campos faltantes
    const missingFields = fields.filter(f => {
      // Validar si el campo existe y no es nulo
      const fieldValue = item[f.key]
      if (fieldValue === undefined || fieldValue === null || fieldValue === '') return true

      // Validar según el tipo de dato esperado
      switch (f.key) {
        case 'ppu':
        case 'year':
        case 'date':
        case 'generation':
        case 'uid':
          return typeof fieldValue === 'string' && fieldValue.trim() === ''
        case 'purchasePrice':
        case 'priceList':
        case 'mileage':
        case 'owners':
          return !isValidNumber(fieldValue)
        case 'acquisitionType':
          return !fieldValue || (typeof fieldValue === 'object' && !fieldValue.id)
        case 'owner':
        case 'personType':
          return fieldValue?.length === 0
        default:
          return !fieldValue
      }
    }).map(f => f.label)

    // Array para almacenar todos los mensajes de error
    const errorMessages = []

    // Agregar campos requeridos faltantes
    if (missingFields.length > 0) {
      missingFields.forEach(field => {
        errorMessages.push(`Campo requerido: ${field}`)
      })
    }

    // Agregar error de llave si existe
    if (item.keyErrorMessage?.length) {
      errorMessages.push(`${item.keyErrorMessage}`)
    }

    // Agregar advertencia de bono de renovación si existe
    if (item.renewalBonusWarningMessage?.length) {
      errorMessages.push(`${item.renewalBonusWarningMessage}`)
    }

    // Obtener diferencias con CAV
    const differences = this.filteredCavDifferences(item)
    if (differences.length) {
      differences.forEach(diff => {
        errorMessages.push(diff.replace(/CAV=|Actual=/g, ''))
      })
    }

    // Agregar otros mensajes de error si existen
    const otherErrors = item.errorMessages?.trim().replace('Diferencias con CAV', '').trim()
    if (otherErrors) {
      // Filtrar errores vacíos o solo espacios
      const errorList = otherErrors.split(',').map(error => error.trim()).filter(error => error.length > 0)
      if (errorList.length > 0) {
        errorList.forEach(error => {
          // Evitar duplicados que ya están en otras categorías
          if (!errorMessages.includes(error) &&
              !error.includes('Llave duplicada') &&
              !error.includes(item.renewalBonusWarningMessage)) {
            errorMessages.push(error)
          }
        })
      }
    }

    return errorMessages
  }

  get disabledSelector () {
    const { stocks } = this
    return stocks.every(stock => !this.checkItem(stock))
  }

  closeAddRecordDialog () {
    this.cleanForm = false
    this.showAddRecordDialog = false
    this.editRecordData = null
    if (!this.stocks.length) {
      this.dialog = true
    }
    this.currentItem = null
  }

  openEditRecordDialog (item) {
    // Copiar los datos del registro para edición
    this.editRecordData = { ...item }
    this.showAddRecordDialog = true
  }

  onRecordEdited (formData) {
    if (!formData) return
    // Buscar el índice del registro editado
    const index = this.stocks.findIndex(stock => stock.id === formData.id)

    // Solo procesar si el registro existe en stocks
    if (index !== -1) {
      // Eliminar el registro
      this.stocks.splice(index, 1)

      // Actualizar dataTableData solo si el registro existía en stocks
      this.dataTableData = {
        ...this.dataTableData,
        [formData.id]: formData,
      }

      this.loadNotification({
        message: 'Registro editado correctamente',
        color: 'success',
      })
    }
  }

  removeRecord (item) {
    const index = this.stocks.findIndex(stock => stock.id === item.id)
    if (index !== -1) {
      this.stocks.splice(index, 1)
    }
  }

  updateKeys (item = null) {
    this.stocks.forEach(stock => {
      if (stock?.key) {
        const index = this.keysAvailable.findIndex(key => key.id === stock.key)
        if (index !== -1 && !this.keysAvailable[index].name.includes('*') && this.keysAvailable[index].name.includes('Disponible')) {
          this.keysAvailable[index].name = `${this.keysAvailable[index].id} - ${stock.brand.match?.name} ${stock.model.match?.name} ${stock.year} ${stock.version.match?.name} ${stock.ppu} *`
        }
      }
    })
    if (!item) return
    const index = this.keysAvailable.findIndex(key => key.id === item.key)
    if (index !== -1) {
      const name = `${item.brand.match?.name} ${item.model.match?.name} ${item.year} ${item.version.match?.name} ${item.ppu} *`
      const indexKey = this.keysAvailable.findIndex(key => key.name.toLowerCase().includes(name.toLowerCase()))
      if (indexKey !== -1) {
        this.keysAvailable[indexKey].name = `${this.keysAvailable[indexKey].id} - Disponible`
      }

      if ((this.keysAvailable[index].name !== name && !this.keysAvailable[index].name.includes('*')) || this.keysAvailable[index].name.includes('Disponible')) {
        this.keysAvailable[index].name = `${this.keysAvailable[index].id} - ${name}`
      }
    }
    this.validateKeyDuplication(item)
    this.changeKey += 1
  }
  }
